import { IFormViewForm } from 'components/FormView';

const PrintTransmitPO: IFormViewForm = {
    id: 'PrintTransmitPOForm',
    layout: {
        rows: 1,
        columns: 1,
    },
    fields: [
        {
            id: '1',
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                name: 'activity',
                fullWidth: true,
                elevation: 0
            },
            position: {
                row: 1,
                col: 1,
                colspan: 3

            },
            children: [
                {
                    id: 1,
                    type: 'SUBHEADER',
                    visible: true,
                    props: {
                        value: 'Purchase order status will be updated to Transmitted.',
                    }
                },
                {
                    group: {
                        style: {
                            flexWrap: 'wrap',
                            justifyContent: 'flex-start',
                            marginTop: 20,
                        },
                        childern: [
                            {
                                id: 2,
                                type: 'TYPOGRAPHY',
                                props: {
                                    text: 'Transmit',
                                    type: 'custom',
                                    customStyles: {
                                        textAlign: 'right',
                                        width: 145,
                                        marginRight: 25,
                                        padding: '4px 0px 0px 0px'
                                    }
                                }
                            },
                            {
                                id: 3,
                                type: 'TEXT_FIELD',
                                style: {
                                    display: 'inline-block',
                                    width: '58%'
                                },
                                props: {
                                    name: 'TransmitVia',
                                    placeholder: '',
                                    size: 'large',
                                    precedentFields: ['TransmitViaReadOnly'],
                                }
                            },
                        ]
                    }
                },
                {
                    id: 4,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '23%',
                        paddingLeft: 37,
                    },
                    props: {
                        name: 'PrintPurchaseOrder',
                        defaultValue: false,
                        solidLabel: true,
                        label: 'Output to',
                        style: {
                            width: 155,
                            paddingTop: 14,
                        }
                    }
                },
                {
                    id: 5,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '66%',
                        paddingLeft: 8,
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'PrintPO',
                        fieldId: 'PrintPurchaseOrderOutput',
                        documentType: 'PO',
                        isCustomerSupplierScoped: true,
                        precedentFields: ['PrintPurchaseOrder'],
                    }
                },
            ]
        }
    ]
};

export default PrintTransmitPO;
